import { createContext, useState, useContext, useCallback } from "react";
import $ from "jquery";

export const PointContext = createContext();

export function PointProvider({ children }) {
    const [point, setPoint] = useState(0);
    const [todayAttendance, setTodayAttendance] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showInsufficientPopup, setShowInsufficientPopup] = useState(false);
    const [requiredPoint, setRequiredPoint] = useState(0);

    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const APIKEY = process.env.REACT_APP_UNSE_API_KEY;
    const siteCode = process.env.REACT_APP_SITE_CODE_LIGHTHOUSE;

    const fetchPoint = useCallback((memberId) => {
        if (!memberId || memberId === 'null' || memberId === 'undefined') {
            setPoint(0);
            setTodayAttendance(false);
            return;
        }

        $.ajax({
            url: `${API_BASE_URL}/getPoint`,
            type: "POST",
            contentType: "application/json",
            dataType: "json",
            data: JSON.stringify({ member_id: memberId, site_code: siteCode }),
            headers: { APIKEY: APIKEY },
            success: function (res) {
                if (res.code === '0') {
                    setPoint(res.point || 0);
                    setTodayAttendance(res.today_attendance || false);
                }
            },
            error: function (err) {
                console.error("포인트 조회 에러:", err);
            }
        });
    }, [API_BASE_URL, APIKEY, siteCode]);

    const checkAttendance = useCallback((memberId, onSuccess) => {
        if (!memberId || memberId === 'null' || memberId === 'undefined') {
            alert('로그인이 필요합니다.');
            return;
        }

        if (todayAttendance) {
            alert('이미 오늘 출석체크를 하셨습니다.');
            return;
        }

        setLoading(true);

        $.ajax({
            url: `${API_BASE_URL}/checkAttendance`,
            type: "POST",
            contentType: "application/json",
            dataType: "json",
            data: JSON.stringify({ member_id: memberId, site_code: siteCode }),
            headers: { APIKEY: APIKEY },
            success: function (res) {
                setLoading(false);
                if (res.code === '0') {
                    setPoint(res.current_point || 0);
                    setTodayAttendance(true);
                    if (onSuccess) {
                        onSuccess(res.point_earned);
                    }
                } else {
                    alert(res.msg || '출석체크에 실패했습니다.');
                }
            },
            error: function (err) {
                setLoading(false);
                console.error("출석체크 에러:", err);
                alert('출석체크 중 오류가 발생했습니다.');
            }
        });
    }, [API_BASE_URL, APIKEY, siteCode, todayAttendance]);

    // 자동 출석체크 (로그인 시 자동 호출, 알림 없이)
    const autoCheckAttendance = useCallback((memberId, onSuccess) => {
        if (!memberId || memberId === 'null' || memberId === 'undefined') {
            return;
        }

        if (todayAttendance) {
            return; // 이미 출석함
        }

        $.ajax({
            url: `${API_BASE_URL}/checkAttendance`,
            type: "POST",
            contentType: "application/json",
            dataType: "json",
            data: JSON.stringify({ member_id: memberId, site_code: siteCode }),
            headers: { APIKEY: APIKEY },
            success: function (res) {
                if (res.code === '0') {
                    setPoint(res.current_point || 0);
                    setTodayAttendance(true);
                    if (onSuccess) {
                        onSuccess(res.point_earned);
                    }
                }
            },
            error: function (err) {
                console.error("자동 출석체크 에러:", err);
            }
        });
    }, [API_BASE_URL, APIKEY, siteCode, todayAttendance]);

    const showPointInsufficient = useCallback((required, current) => {
        setRequiredPoint(required);
        setShowInsufficientPopup(true);
    }, []);

    const hidePointInsufficient = useCallback(() => {
        setShowInsufficientPopup(false);
        setRequiredPoint(0);
    }, []);

    const updatePointAfterUse = useCallback((usedAmount) => {
        setPoint(prev => Math.max(0, prev - usedAmount));
    }, []);

    return (
        <PointContext.Provider value={{
            point,
            setPoint,
            todayAttendance,
            setTodayAttendance,
            loading,
            fetchPoint,
            checkAttendance,
            autoCheckAttendance,
            showInsufficientPopup,
            requiredPoint,
            showPointInsufficient,
            hidePointInsufficient,
            updatePointAfterUse
        }}>
            {children}
        </PointContext.Provider>
    );
}

export function usePoint() {
    const context = useContext(PointContext);
    if (!context) {
        throw new Error('usePoint must be used within a PointProvider');
    }
    return context;
}
